import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SSOButton({ provider, url, disabled }) {
    const handleClick = ()=>{
        if (!disabled && url) {
            window.location.href = url;
        }
    };
    const googleIcon = /*#__PURE__*/ _jsxs("svg", {
        className: "w-5 h-5",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Google logo"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#4285F4",
                d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#34A853",
                d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#FBBC05",
                d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#EA4335",
                d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            })
        ]
    });
    const microsoftIcon = /*#__PURE__*/ _jsxs("svg", {
        className: "w-5 h-5",
        viewBox: "0 0 23 23",
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Microsoft logo"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#f35325",
                d: "M0 0h11v11H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#81bc06",
                d: "M12 0h11v11H12z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#05a6f0",
                d: "M0 12h11v11H0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#ffba08",
                d: "M12 12h11v11H12z"
            })
        ]
    });
    const config = provider === 'google' ? {
        label: 'Continue with Google',
        bgColor: 'bg-white',
        hoverColor: 'hover:bg-gray-50',
        textColor: 'text-gray-700',
        borderColor: 'border-gray-300',
        icon: googleIcon
    } : provider === 'google_workspace' ? {
        label: 'Continue with Google Workspace',
        bgColor: 'bg-white',
        hoverColor: 'hover:bg-gray-50',
        textColor: 'text-gray-700',
        borderColor: 'border-gray-300',
        icon: googleIcon
    } : provider === 'microsoft_azure' ? {
        label: 'Continue with Microsoft Azure AD',
        bgColor: 'bg-white',
        hoverColor: 'hover:bg-gray-50',
        textColor: 'text-gray-700',
        borderColor: 'border-gray-300',
        icon: microsoftIcon
    } : {
        label: 'Continue with Microsoft',
        bgColor: 'bg-white',
        hoverColor: 'hover:bg-gray-50',
        textColor: 'text-gray-700',
        borderColor: 'border-gray-300',
        icon: microsoftIcon
    };
    const baseClasses = 'w-full flex items-center justify-center gap-3 px-4 py-3';
    const borderClasses = `border ${config.borderColor}`;
    const colorClasses = `${config.bgColor} ${config.textColor}`;
    const styleClasses = 'font-medium rounded-lg shadow-sm transition-colors';
    const interactiveClasses = `${config.hoverColor} focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`;
    const disabledClasses = 'disabled:opacity-50 disabled:cursor-not-allowed';
    const buttonClasses = `${baseClasses} ${colorClasses} ${borderClasses} ${styleClasses} ${interactiveClasses} ${disabledClasses}`;
    return /*#__PURE__*/ _jsxs("button", {
        type: "button",
        onClick: handleClick,
        disabled: disabled,
        className: buttonClasses,
        children: [
            config.icon,
            config.label
        ]
    });
}
